import axios, {AxiosResponse} from 'axios';
import {
    CompaniesRetrieveResponse, CompanyRetrieveResponse, CompanyStudySyncRetrieveResponse, StudyMappingsRetrieveResponse,
    StudySourceCodesRetrieveResponse, StudyTargetCodesRetrieveResponse, SyncCdmsStudiesRetrieveResponse, SyncR3StudiesRetrieveResponse,
    CompanyPropertyAuditTrailsResponse, StudyMappingAuditTrailsResponse
} from '@/model/CommonModel';
import ApiUtils from '@/utils/ApiUtils';

export default class SystemApi {
    public static retrieveCompanies(params: any = {}): Promise<CompaniesRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors`, {params})
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveStudyMappings(companyKey: number, params: any = {}): Promise<StudyMappingsRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${companyKey}/study-mapping`, {params})
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveCompany(companyKey: number): Promise<CompanyRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${companyKey}`)
            .then((res: AxiosResponse) => res.data);
    }

    public static getCompanyPropertyAuditTrails(companyKey: number, params: any = {}): Promise<CompanyPropertyAuditTrailsResponse> {
        return axios
            .get(`/1.0/sponsors/${companyKey}/audit-trail`, {params})
            .then((res: AxiosResponse) => res.data);
    }
    
    public static saveCompany(companyKey: number, param: any) {
        return axios
            .post(`/1.0/sponsors/${companyKey}`, param)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveStudyMapping(companyKey: number | string, studyKey: number | string): Promise<CompanyStudySyncRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${companyKey}/study-mapping/${studyKey}`)
            .then((res: AxiosResponse) => res.data);
    }

    public static getStudyMappingAuditTrails(companyKey: number | string, studyKey: number | string)
                                    : Promise<StudyMappingAuditTrailsResponse> {
        return axios
            .get(`/1.0/sponsors/${companyKey}/study-mapping/${studyKey}/audittrails`)
            .then((res: AxiosResponse) => res.data);
        }
    
    public static retrieveStudyMappingTarget(companyKey: number | string): Promise<StudyTargetCodesRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${companyKey}/study-mapping/target`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveStudyMappingSource(companyKey: number | string): Promise<StudySourceCodesRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${companyKey}/study-mapping/source`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static saveStudyMapping(companyKey: number | string, studyKey: number | string, param: any) {
        return axios
            .post(`/1.0/sponsors/${companyKey}/study-mapping/${studyKey}/save`, param)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveCdmsStudies(companyKey: string, params: any = {}): Promise<SyncCdmsStudiesRetrieveResponse> {
        return axios
            .get(`/1.1/sponsors/${companyKey}/study-mapping/source`, {params})
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveR3Studies(companyKey: string, params: any = {}): Promise<SyncR3StudiesRetrieveResponse> {
        return axios
            .get(`/1.1/sponsors/${companyKey}/study-mapping/target`, {params})
            .then((res: AxiosResponse) => res.data);
    }

    public static retrieveUsers(params: any = {}): Promise<any> {
        return axios
            .get(`/1.0/sponsor/users`, {params})
            .then((res: AxiosResponse) => res.data);
    }

    public static downloadExcelCompanyUserList(): Promise<any> {
        return axios
            .get('/1.0/system-companies/download', {responseType: 'blob'})
            .then((res: any) => ApiUtils.isFailToFileDownloadResponse(res)
                ? ApiUtils.handleFileDownloadFailResponse(res)
                : ApiUtils.handleFileDownloadSuccessResponse(res));
    }
    
}
